/**
 * Connector name validation — single frontend source of truth.
 *
 * Mirrors the backend rules in `src/lakehouse/api/validators/connector_name.py`
 * (`CONNECTOR_NAME_PATTERN` / `validate_connector_name` /
 * `get_connector_name_error_message`):
 *   - must start with a letter (a-z, A-Z)
 *   - then letters, numbers, spaces, underscores, hyphens
 *   - 1–64 characters total
 *
 * Used by the create-connector wizard (Configure step) and the detail-page
 * rename so the user is blocked up front, not only at final submit.
 */

// Keep in sync with backend CONNECTOR_NAME_PATTERN.
export const CONNECTOR_NAME_PATTERN = /^[a-zA-Z][a-zA-Z0-9 _-]{0,63}$/;

// Verbatim copy of backend get_connector_name_error_message().
export const CONNECTOR_NAME_ERROR =
  'Invalid connector name. Name must start with a letter (a-z, A-Z) ' +
  'and can only contain letters, numbers, spaces, underscores, and hyphens. ' +
  'Maximum length is 64 characters.';

/**
 * True when `name` satisfies the connector-name format. Validates the value as
 * given (no trimming) so callers match exactly what the backend will receive.
 */
export const validateConnectorName = (name: string): boolean =>
  CONNECTOR_NAME_PATTERN.test(name);
